import moment from "moment";
export var billDefaultDate = function () {
    var date = new Date(), preMonthTime = new Date(date.getFullYear(), date.getMonth() - 1, date.getDate()).getTime();
    return {
        Start: new Date(preMonthTime + 86400000),
        End: new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59)
    };
};
export var indexApplyOrderDate = function () {
    var date = new Date(), preMonthTime = new Date(date.getFullYear(), date.getMonth() - 6, date.getDate()).getTime();
    return {
        Start: new Date(preMonthTime + 86400000),
        End: new Date()
    };
};
export var clientBillDefaultDate = function () {
    return {
        Start: new Date(new Date().getTime() - 1000 * 60 * 60 * 24),
        End: new Date(new Date().getTime() + 1000 * 60 * 60 * 24)
    };
};
export var weekDefaultDate = function () {
    var date = new Date();
    return {
        Start: date,
        Tomorrow: moment(new Date).add('days', 1).toDate(),
        End: moment(new Date).add('week', 1).toDate()
    };
};
export var currMonthDefaultDate = function () {
    var date = new Date();
    return {
        Start: new Date(date.getFullYear(), date.getMonth(), 1),
        End: new Date()
    };
};
export var beforeWeektDate = function () {
    var currentWeekDay = new Date().getDay();
    return {
        Start: new Date(Date.now() - 24 * 3600 * 1000 * 7),
        End: new Date()
    };
};
